import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description SoftSkills icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { SoftSkills } from '@sravni/design-system-icons'
 *
 * <SoftSkills />
 * ```
 */
var SoftSkills = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "SoftSkills", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { clipRule: "evenodd", d: "M15.833 17.5H4.167c-.921 0-1.667-.746-1.667-1.667V4.167c0-.921.746-1.667 1.667-1.667h11.666c.921 0 1.667.746 1.667 1.667v11.666c0 .921-.746 1.667-1.667 1.667Z", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "m10 12.854 2 1.043a.53.53 0 0 0 .77-.555l-.383-2.21 1.619-1.564a.525.525 0 0 0-.294-.898l-2.236-.322-1-2.012a.532.532 0 0 0-.952 0l-1 2.011-2.236.323a.526.526 0 0 0-.294.898l1.619 1.565-.382 2.209a.53.53 0 0 0 .77.555l2-1.043", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))); });

export { SoftSkills };
//# sourceMappingURL=SoftSkills.js.map
